import React, { useEffect, useState } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Image from "../../assets/Images/bookkeeperImg2.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { usePlaidLink } from "react-plaid-link";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  getBanks,
  getLinkBankToken,
  getTransactions,
  getTransactionsStatus,
  getTransactionsTableData,
  userExchangeToken,
} from "../../stores/clients";
import ListLoadingNew from "../common-components/ListLoadingNew";
import { useNavigate } from "react-router-dom";

export const SetupBookkeeper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLargeScreen = useMediaQuery("(max-width:1440px)");
  const token = localStorage.getItem("user_token");
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [linkToken, setLinkToken] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Generate a link token when the component mounts
  useEffect(() => {
    dispatch<any>(getLinkBankToken()).then((res: any) => {
      setLinkToken(res?.payload?.link_token);
      console.log(res);
    });
    const transcationStatus = async () => {
      try {
        const response = await dispatch<any>(getTransactionsStatus()).unwrap();
        await dispatch<any>(
          getTransactionsTableData({
            page: 1,
            limit: 10,
            transaction_type: 1,
            filter_by_category: 0,
            start_date: "",
            end_date: "",
            search: "",
          })
        ).then((res: any) => {
          if (res?.payload?.data?.transactions?.length > 0) {
            navigate("/tools/bookkeeper/dashboard");
          }
        });
        console.log(response);
        if (
          response?.data?.step === 1 ||
          response?.data?.step === 0 ||
          response?.data?.step === -1
        ) {
          navigate("/tools/bookkeeper");
        } else if (response?.data?.step === 3) {
          navigate("/tools/bookkeeper/dashboard");
        }
      } catch (error: any) {
        console.log(error.response?.data?.error || error.message);
      }
    };

    transcationStatus();
  }, []);

  const config = {
    token: linkToken,
    onSuccess: async (publickToken: string, metaData: any) => {
      const response = await dispatch<any>(
        userExchangeToken({ public_token: publickToken })
      ).unwrap();
      const res = await dispatch<any>(getTransactionsStatus()).unwrap();
      if (res?.data?.step === 1 || res?.data?.step === 0) {
        navigate("/tools/bookkeeper");
      } else if (res?.data?.step === 3) {
        navigate("/tools/bookkeeper/dashboard");
      }
    },
    onExit: () => {
      setLoading(false);
      console.log("exited");
    },
  };

  const { open, ready } = usePlaidLink(config);

  // Handle Plaid Link success
  const handleClick = (e: any) => {
    e.preventDefault(); // Prevent any default behavior
    setBtnLoading(true);
    // Set a flag to prevent multiple clicks
    if (ready && linkToken) {
      setTimeout(() => {
        open();
        setLoading(true);
        setBtnLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return <ListLoadingNew />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: isMobile ? 0 : 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "100vh",
          width: "100%",
          padding: isMobile ? 0 : 2,
          bgcolor: "white",
          marginTop: 1,
          paddingTop: isMobile ? 2 : 8,
          paddingBottom: 5,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <img
            src={Image}
            alt="Operating Agreement"
            style={{
              maxWidth: isLargeScreen ? "200px" : "256px",
              height: isLargeScreen ? "210px" : "268px",
            }}
          />
          <div
            style={{
              marginTop: isMobile ? "20px" : "14px",
              display: "grid",
              padding: isMobile ? "0 12px" : "0",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "20px" : isTablet ? "24px" : "28px",
                fontWeight: 700,
                textAlign: "center",
                margin: 0,
              }}
            >
              Almost there!
            </p>
            <p
              style={{
                fontSize: isMobile ? "12px" : isTablet ? "15px" : "16px",
                color: "#6C6F71",
                width: isMobile ? "100%" : isTablet ? "400px" : "528px",
                textAlign: "center",
                paddingTop: isMobile ? 8 : 12,
                margin: isMobile ? "8px 0 0 0" : "auto",
              }}
            >
              Connect your bank account securely using Plaid to start tracking
              your income and expenses.
            </p>
            <button
              style={{
                margin: "auto",
                paddingTop: isMobile ? "12px" : "16px",
                paddingBottom: isMobile ? "12px" : "16px",
                paddingLeft: isMobile ? "24px" : "30px",
                paddingRight: isMobile ? "24px" : "30px",
                borderRadius: "8px",
                background: btnLoading
                  ? "#BDBDBD"
                  : "linear-gradient(to right, #2977CC, #1D538F)",
                color: "white",
                border: "none",
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: 600,
                marginTop: isMobile ? "16px" : "24px",
                cursor: "pointer",
                minWidth: isMobile ? "140px" : "auto",
                height: "52px",
                opacity: btnLoading ? 0.7 : 1,
              }}
              onClick={handleClick}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                </span>
              ) : (
                "Connect Bank Account"
              )}
            </button>
            <div
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#6C6F71",
                backgroundColor: "#EAF1FA66",
                padding: isMobile ? "5px 10px" : "10px 20px",
                borderRadius: "12px",
                marginTop: "24px",
                width: "100%",
                textAlign: "center",
                marginBottom: 40,
              }}
            >
              🔒 Bank-level security. Your information is encrypted and never
              stored.
            </div>
          </div>
        </Box>
      </Box>
    </Box>
  );
};
